<template>
	<div class="conten">
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<!-- <el-form-item>
					<el-input v-model="secah.orderSubNo" placeholder="请输入订单号" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="secah.tel" placeholder="请输入联系人电话" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-date-picker v-model="value" type="datetimerange" :picker-options="pickerOptions"
					  value-format='yyyy-MM-dd HH:mm:ss'
						range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
					</el-date-picker>
				</el-form-item> -->
				<!-- <el-form-item>
					<el-select v-model="secah.orderType" placeholder="请选择订单类型" clearable>
						
						<el-option label="商城订单" :value="1">
						</el-option>
						<el-option label="拼团订单" :value="2">
						</el-option>
					</el-select>
				
				</el-form-item> -->
				<el-form-item>
					<el-input v-model="secah.orderRefundNo" placeholder="请输入退款单号" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-select v-model="secah.orderDetailStatus" placeholder="请选择订单状态" clearable>
						
						<el-option label="申请中" :value="2">
						</el-option>
						<el-option label="退货中" :value="3">
						</el-option>
						<el-option label="已退货" :value="4">
						</el-option>
						<!-- <el-option label="已退款" :value="5">
						</el-option> -->
					</el-select>
				
				</el-form-item>
				<el-form-item>
					<el-button @click='secahClick'>搜索</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<div>
			<el-table :data="tableData" style="width: 100%" border>
				<el-table-column prop="orderRefundNo" label="退款单号" align="center"></el-table-column>
				<el-table-column prop="refundExpressCompany" label="快递公司" align="center">
				
				</el-table-column>
				<el-table-column prop="refundExpressNo" label="快递编号" align="center">
				</el-table-column>
				
				<el-table-column prop="orderSubStatus" label="状态" align="center">
					<template slot-scope="scope">
						{{scope.row.orderDetailStatus==2?'申请中':scope.row.orderDetailStatus==3?"申请通过":scope.row.orderDetailStatus==4?"待收货":scope.row.orderDetailStatus==5?"已收货":"申请失败"}}
					</template>
				</el-table-column>
				<el-table-column prop="refundType" label="退款类型" align="center">
					<template slot-scope="scope">
						{{scope.row.refundType==2?'退货退款':"退款"}}
					</template>
				</el-table-column>
				<el-table-column prop="goodsPrice" label="商品价格" align="center">
				</el-table-column>
				<el-table-column prop="goodsNum" label="商品数量" align="center">
				</el-table-column>
				<el-table-column prop="refundFreight" label="运费" align="center">
				</el-table-column>
				<el-table-column prop="refundFreight" label="退款金额" align="center">
					<template slot-scope="scope">
						{{((scope.row.goodsPrice*scope.row.goodsNum)*100-scope.row.refundFreight*100)/100}}
					</template>
				</el-table-column>
				<el-table-column prop="integral" label="订单积分" align="center">
				</el-table-column>
				<el-table-column prop="jkcMoney" label="JKC券" align="center">
				</el-table-column>
				<el-table-column prop="refundTime" label="申请时间" align="center">
				</el-table-column>
				<!-- <el-table-column prop="freight" label="订单运费" align="center">
				</el-table-column>
				<el-table-column prop="receiveName" label="联系人" align="center">
				</el-table-column>
				<el-table-column prop="receiveTel" label="联系人电话" align="center">
				</el-table-column>
				<el-table-column prop="address" label="收货人地址" align="center">
				</el-table-column> -->
				<el-table-column fixed="right" label="操作" width="300" align="center">
					<template slot-scope="scope">
						<el-button size="mini" type="success" v-if="scope.row.orderDetailStatus==2" @click="confirmRefund(scope.row)">确定通过</el-button>
						<el-button size="mini" type="danger" v-if="scope.row.orderDetailStatus==2" @click="toPass(scope.row)">拒绝通过</el-button>
						<el-button size="mini" type="warning" v-if="scope.row.orderDetailStatus==4" @click="confirmReceipt(scope.row)">确定收货</el-button>
						<el-button size="mini" type="primary" @click="detailsClick(scope.row)">详情</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="secah.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="10"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
		<el-dialog title="订单信息" :visible.sync="dialogVisible" :modal-append-to-body='false' width="60%">
			<div>
				<el-descriptions title="">
					<el-descriptions-item label="退款单号">{{details.orderRefundNo}}</el-descriptions-item>
					<el-descriptions-item label="快递公司">{{details.refundExpressCompany}}</el-descriptions-item>
					<el-descriptions-item label="快递编号">{{details.refundExpressNo}}</el-descriptions-item>
					<el-descriptions-item label="退款类型">
						{{details.refundType==2?'退货退款':"退款"}}
					</el-descriptions-item>
					<el-descriptions-item label="状态">
					{{details.orderDetailStatus==2?'申请中':details.orderDetailStatus==3?"申请通过":details.orderDetailStatus==4?"待收货":details.orderDetailStatus==5?"已收货":"申请失败"}}
					</el-descriptions-item>
					<el-descriptions-item label="商品价格">{{details.goodsPrice}}</el-descriptions-item>
					<el-descriptions-item label="商品数量">{{details.goodsNum}}</el-descriptions-item>
					<el-descriptions-item label="运费">{{details.refundFreight}}</el-descriptions-item>
					<el-descriptions-item label="退款金额">
					{{((details.goodsPrice*details.goodsNum)*100-details.refundFreight*100)/100}}
					</el-descriptions-item>
					
					<!-- <el-descriptions-item label="申请时间">{{details.refundTime}}</el-descriptions-item>
					<el-descriptions-item label="退款原因">{{details.refundReason}}</el-descriptions-item> -->
				</el-descriptions>
				<!-- <div class="el-descriptions-item__container"><span
						class="el-descriptions-item__label has-colon ">备注</span><span
						class="el-descriptions-item__content">{{details.refundDesc}}</span></div> -->
				<!-- <el-table :data="details.orderDetailList" style="width: 100%;margin-top: 20px;" border>
					<el-table-column prop="goodsName" label="商品名称" align="center">
					</el-table-column>
					<el-table-column prop="attribute" label="商品属性" align="center">
						<template slot-scope="scope">
							<span>{{goodsSpecsStr(scope.row.goodsSpecs)}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="goodsPrice" label="商品价格" align="center">
					</el-table-column>
					<el-table-column prop="goodsNum" label="购买数量" align="center">
					</el-table-column>
					<el-table-column prop="integral" label="积分" align="center">
					</el-table-column>
					<el-table-column prop="jkcMoney" label="JKC券" align="center">
					</el-table-column>

				</el-table> -->
				<div v-if="details.refundVoucherAttachmentList" style="padding-top:20px; font-weight: bold;">退款附件</div>
				<viewer>
				<img v-if="details.refundVoucherAttachmentList" style="width: 100px;height: 100px;margin: 10px;" 
					:src="webUrl+details.refundVoucherAttachmentList"
				/>
				</viewer>
			</div>

		</el-dialog>

		
		
		<el-dialog :close-on-click-modal='false' :close-on-press-escape='false' title="客户详情" :visible.sync="isapply" :modal-append-to-body='false' width="600px">
			<el-form >
				<el-form-item label="说明" label-width='100px'>
					<el-input v-model="refuseRefundDesc" type="textarea" autocomplete="off" placeholder="请输入申请失败说明"></el-input>
				</el-form-item>
				
			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="isapply = false">取 消</el-button>
				<el-button type="primary" @click="sub()">确 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>


<script>
	export default {
		data() {
			return {
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				value: "",
				tableData: [],
				total: 0,
				secah: {
						orderSubStatus: '',
						pageNum: 1,
						pageSize: 10,
						// orderSubNo:"",
						// tel:"",
						orderRefundNo:"",
						orderType:1
				},
				dialogVisible: false,
				details: {},
				isDeliver:false,
				form:{
					expressCompany:"",
					expressNo:"",
					orderSubId:""
				},
				isapply:false,
				refuseRefundDesc:"",
				orderDetailId:""

			}
		},
		created() {
			this.getList()
		},
		methods: {
			//过滤属性
			goodsSpecsStr(goodsSpecs){
				var str=''
				var goodsSpecs=JSON.parse(goodsSpecs)
				for(var key in goodsSpecs){
					str+=key+"："+goodsSpecs[key]+' '
				}
				return str
			},
			//搜索
			secahClick() {
				this.secah.pageNum=1
				this.getList()
			},
			//确定通过
			confirmRefund(row){
				this.httpPost("/order/agreeRefundApply?"+this.$qs.stringify(
				{
					orderDetailId:row.orderDetailId,
					
				}
				)).then(res => {
					console.log(res.data)
					if (res.code == 200) {
						this.getList()
					}
				})
			},
			//拒绝通过弹框
			toPass(row){
				this.isapply=true
				this.orderDetailId=row.orderDetailId
				
			},
			//拒绝通过
			sub(){
				if(this.refuseRefundDesc.length==0){
					this.$message('请输入申请失败说明');
					return false
				}
				this.httpPost("/order/refuseRefundApply?"+this.$qs.stringify({
					orderDetailId:this.orderDetailId,
					refuseRefundDesc:this.refuseRefundDesc,
					})).then(res => {
					console.log(res.data)
					if (res.code == 200) {
						this.isapply=false
						this.getList()
					}
				})
			},
			//确定收货
			confirmReceipt(row){
				this.httpPost("/order/confirmRefund?"+this.$qs.stringify({orderDetailId:row.orderDetailId})).then(res => {
					console.log(res.data)
					if (res.code == 200) {
						this.getList()
					}
				})
			},
			//详情
			detailsClick(row) {
				this.httpPost("/order/getDetailOne?"+this.$qs.stringify({orderDetailId:row.orderDetailId})).then(res => {
					console.log(res.data)
					if (res.code == 200) {
						this.details=res.data						
						this.dialogVisible = true
					}
				})
				

				
			},
			
			//选择分页条数
			handleSizeChange(e) {
				this.secah.pageNum = 1
				this.secah.pageSize = e
				this.getList()
			},
			//页码
			handleCurrentChange(e) {
				this.secah.pageNum = e
				this.getList()
			},
			//获取列表信息
			getList(){
				console.log(this.value)
				if(this.value){
					this.secah.startTime=this.value[0]
					this.secah.endTime=this.value[1]
				}
				this.httpPost("/order/orderDetailByPage", this.secah, true, {
					'Content-Type': 'application/json'
				}).then(res => {
					console.log(res.data.content)
					if (res.code == 200) {
						this.tableData = res.data.content
						this.total = res.data.total
					}
				})
			},
		},


	}
</script>

<style scoped lang='scss'>
	.page {
		padding: 20px 0;
	}
</style>
